import { createContext, useContext } from 'react';

const FixedHeightRowContext = createContext({
  fixedHeight: false,
});

export const FixedHeightRowProvider = ({ children }: any) => {
  return (
    <FixedHeightRowContext.Provider value={{ fixedHeight: true }}>
      {children}
    </FixedHeightRowContext.Provider>
  );
};

export const useIsFixedHeightRow = () => {
  const ctx = useContext(FixedHeightRowContext);

  return ctx?.fixedHeight ?? false;
};
